import { NavigatorScreenParams } from '@react-navigation/native';
import { lazy } from 'react';
import { centerModalOption } from '../../appComponents/ModalWrapper';
import { wrapNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { PatreonFlowScreenParams } from './components/PatreonFlowPageContent';

const PatreonFlowPageContent = lazy(
  () => import('./components/PatreonFlowPageContent'),
);

const PatreonFlowPage = wrapNavigatorScreen(
  (_: NavigatorScreenParams<PatreonFlowScreenParams> | {}) => {
    return <PatreonFlowPageContent />;
  },
  centerModalOption,
);

export default PatreonFlowPage;
